var App = App || {};

(function() {
	let self = App.modal = {
		shown: false,
		is_rdy: false,
		is_preserve: false,
		window_width: 0,
		window_height: 0,
		width: 0,
		height: 0,
		image_width: 0,
		image_height: 0,
		current_image_width: 0,
		current_image_height: 0,
		future_title: 'no',
		swipe_end: false,
		layer_level: 0,
		tab: '',
		dismissible: true, // Closes the modal when Esc key is pressed or a backdrop is clicked
		window: null,

		obj_window: null,
		obj_overlay: null,
		obj_params: null,
		obj_wrapper: null,

		obj_hold_delete: null,
		obj_hold_delete_all: [],

		debug: false,

		is_shown: function () {
			return self.shown && self.obj_window != null;
		},
		is_ready: function () {
			return self.is_rdy;
		},
		is_fullscreen: function () {
			return self.obj_window.hasClass('modal-fullscreen') && !self.obj_window.hasClass('modal-fullpage');
		},
		is_fullpage: function () {
			return self.obj_window.hasClass('modal-fullpage');
		},

		/**
		 * @deprecated
		 */
		show_deprecated: function(caption, url, imageGroup, evt) {
			self.show({
				url: url,
				group: imageGroup,
				title: caption
			});
		},

		/**
		 * 	App.modal.show({
		 * 		url: '/ajax/...',
		 * 		title: 'title',
		 * 		group: 'group',
		 * 		width: 500,
		 * 		ico: 'ico_users'
		 * 	});
		 */

		show: function (data) {

			if (self.debug) {
				console.trace('modal', 'show', { data: { ... data }, self: { ... self } });
			}

			if (App.offline_mode.is_on()) return;

			// to prevent highlight links after ESC pressed (:focus-visible)
			document.activeElement.tagName === 'A' && document.activeElement.blur();

			// if ($('body').hasClass('loading')) return false;
			let url = data.url || '';
			let force_html = data.html || '';
			if (!url && !force_html) {
				App.core.warn('modal.show', 'bad modal window init: ' + JSON.stringify(data));
				return;
			}
			let title = data.title || '';
			let group = data.group || '';
			let overlay = data.overlay || '';
			let params = data.params || '';
			let width = data.width || 450;
			let ico = data.ico || '';
			let post = data.post || false;
			let post_data = data.post_data || {};
			let success = data.success || null;
			let anchor = data.anchor || null;
			let anchor_class = data.anchor_class || 'modal_open';
			self.tab = data.tab || '';
			self.dismissible = data.dismissible ?? true;

			self.window.opening();

			// if (data.onload) $(document).unbind('modal_onload.once').bind('modal_onload.once', data.onload);
			// $(document).unbind('modal_onreload.once')
			// if (data.onreload) $(document).bind('modal_onreload.once', data.onreload);

			title = title ? App.helper.html.encode(title) : '';
			if (!self.obj_overlay) self.saved_scroll_pos = $(window).scrollTop();
			if (params) {
				if (params !== 'same') {
					self.obj_params = $(params);
				}
				self.obj_params.find('input[data-param]').each(function () {
					if (url.indexOf($(this).attr('name') + '=') === -1)	url += '&' + $(this).attr('name') + '=' + encodeURIComponent($(this).val());
				});
			} else self.obj_params = null;

			if (self.helper_validate_preview_url(url)) {
				if (url.indexOf('nopanel') === -1 && ($('body').hasClass('withModalAndTask') || $('body').hasClass('withModalAndTaskDraft'))) {
					data.url = url = App.helper.url.add_query(url, 'nopanel=1');
				}
			} else if ($('body').hasClass('withModalAndTask') || $('body').hasClass('withModalAndTaskDraft')) {
				self.hide({immediate: true, hide_all: true});
			}
			self.history_save(data);

			$('body').addClass('withModal');
			$('#preview_place').hide();
			self.shown = true;
			if (!App.setup_guide.editMode) while (App.menu.is_shown()) App.menu.hide({ just_remove: true });
			if (App.device.is_mobile()) {
				$('body').removeClass('mobileMenuOpen mobileMenuHalfOpen');
				App.core.history?.mobile?.back_on_hide('primary_menu');
			}
			App.core.history?.mobile?.push('modal', ['menu']);


			if (self.obj_window != null) {
				self.obj_window.removeWithComponents();
			}

			if (!self.obj_overlay) {
				self.obj_overlay = $('<div />').attr('class', 'modal__overlay').attr('data-modal-level', self.layer_level).appendTo('#modalContainer').bind('click', (e) => self.on_overlay_click(e));
			}

			let obj_overlay = self.obj_overlay;
			let obj_window = $('<div />');
			let use_show_animation = !data.reload && $(window).width() > APP_SCREEN_THRESHOLD;

			if (use_show_animation) {
				obj_window.css('opacity', '0').css('scale', '0.97').css('transition', 'opacity 0.15s ease-out, scale 0.15s ease-out');
			}

			self.obj_window = obj_window.attr('class', 'modal').appendTo(self.obj_overlay);
			self.obj_window.attr('data-num', self.layer_level);
			self.obj_window.use_show_animation = use_show_animation;

			if (data.onhide) self.obj_window.on('before_hide.modal', data.onhide);

			self.presave_history_dom(self.layer_level);
			self.add_history_classes();

			title = title.replace(/ \| .*/, '');
			if (anchor) $(anchor).addClass(anchor_class);

			self.obj_window.hook_hide = function () {
				if (anchor) $(anchor).removeClass(anchor_class);

				if ($(window).width() > APP_SCREEN_THRESHOLD) {
					obj_window.css('opacity', '0').css('scale', '0.97').css('transition', 'opacity 0.15s ease-out, scale 0.15s ease-out');
				} else {
					obj_window.css('top', '100%');
				}

				obj_overlay.removeClass("modal__overlay-custom").removeClass("modal__overlay-custom-red").removeClass("modal__overlay-custom-green")
					.removeClass("modal__overlay-custom-blue").removeClass("modal__overlay-custom-purple");
				if (self.layer_level == 1) self.window.closed();
			};
			self.obj_window.hook_show = function () {


				obj_overlay.removeClass("modal__overlay-custom-red").removeClass("modal__overlay-custom-green")
					.removeClass("modal__overlay-custom-blue").removeClass("modal__overlay-custom-purple");

				obj_window.css('opacity', '1').css('scale', '1');

				if (group === 'delete' || group === 'delete2' || overlay === 'red') { obj_overlay.addClass("modal__overlay-custom-red"); }
				else if (group === 'reopen') { obj_overlay.addClass("modal__overlay-custom-green"); }
				else if (group === 'close') { obj_overlay.addClass("modal__overlay-custom-blue"); }
				else if (group === 'terms') { obj_overlay.addClass("modal__overlay-custom-purple"); }
				else { obj_overlay.addClass("modal__overlay-custom"); }
				self.window.opened();
			};

			if (self.helper_validate_preview_url(url)) { // specific modal window
				self.window_width = $(window).width();
				self.window_height = $(window).height();
				self.obj_overlay.addClass('modal__overlay-withPanel');
				const min_window_width = Math.max(1024, self.window_width/2);
				let task_view_width = App.right_panel.is_shown() ? App.right_panel.width : $('#taskView__wrapper').width();
				let task_create_width = App.task_create.width;

				if (App.task_view.is_shown() && self.window_width - task_view_width > min_window_width && self.layer_level === 1 && !App.task_view.open_in_fullscreen) {
					self.window_width -= task_view_width;
					$('#modalContainer').css({'--task-width': task_view_width + 'px'});
					$('body').addClass('withModalAndTask');
				} else {
					$('body').removeClass('withModalAndTask');
				}
				if (App.task_create.is_shown() && self.window_width - task_create_width > min_window_width && self.layer_level === 1 && !App.task_create.open_in_fullscreen) {
					self.window_width -= task_create_width;
					$('#modalContainer').css({'--task-draft-width': task_create_width + 'px'});
					$('body').addClass('withModalAndTaskDraft');
				} else {
					$('body').removeClass('withModalAndTaskDraft');
				}
				self.width = self.window_width - 60;
				self.height = self.window_height - 60;
				self.panel.item_width = (self.window_width < 360) ? 210 : 226;
				$('#modal__previewImage').remove();
				App.core.async_task.abort('modal_show');
				self.window.loading();
				App.core.async_task.ajax({
					id: 'modal_show',
					url : url,
					dataType: 'html',
					headers: {'x-load-type': 'modal', 'x-modal-level': self.layer_level - 1},
				}).then(function (html) {
					self.obj_window.removeClass('item_aniq');
					self.obj_window.html(html);

					self.helper_handle_iframe_svg_loading();

					self.remove_obj_hold_delete();

					if (html.indexOf('App.message.error') !== -1) return;

					$('body').addClass('withImagePreview');
					self.init_panel();

					let $file_central_btn = $('#file_central_btn'), $file_central_btn_html = $('#file_central_btn-html');

					if ($file_central_btn_html.length && !App.hybrid_app) {
						$file_central_btn.find('#zoom_data').html($file_central_btn_html.html());
						$file_central_btn.show();

						if (!$('body').hasClass('mobile')) $('#file_central_btn .sw_pre a').hover(function () {
							$(this).parent().addClass('sw_hover');
						}, function () {
							$(this).parent().removeClass('sw_hover');
						});

						$file_central_btn.attr('onclick', $file_central_btn_html.attr('onclick') || null);
						$file_central_btn_html.remove();
					} else {
						$file_central_btn.find('#zoom_data').html('');
						$file_central_btn.attr('onclick', null).hide();
					}

					if ($file_central_btn.attr('onclick') == null && $file_central_btn.find('[onclick]').length === 0) {
						$file_central_btn.css({ pointerEvents: 'none' });
					} else {
						$file_central_btn.css({ pointerEvents: '' });
					}

					if ($('#modal__previewImage').length) {
						if ($('#modal__previewImage').attr('rel') === 'load') {
						} else {
							self.onimage_load_success();
						}
					} else {
						if ($('#modal__alert').length) {
							self.width = 320;
							self.height = 500;
						}
						if ($('#modal__previewVideo').length) {
							self.width = 800;
							self.height = 600;
							self.obj_window.addClass('modal-transparent');
						}
						if ($('#modal__previewAudio').length) {
							self.width = 400;
							self.height = 70;
							self.obj_window.addClass('modal-transparent');
						}
						self.obj_window.show();
					}
					if ($('#modal__alert .extbig').length) self.obj_window.attr('data-group', 'extbig'); else self.obj_window.removeAttr('data-group');
					$("#modal__previewPanel").show();
					setTimeout(self.obj_window.hook_show, 1);
					self.update_size();
				}).catch(function () {
					self.window.loadFailed();
				});
			} else {
				self.obj_overlay.removeClass('modal__overlay-withPanel');
				let query = url.replace(/^[^\?]+\??/, '');
				if (query[0] === '?') query = query.substr(1);
				let params = App.helper.url.parse_query(query);
				self.width = width;
				self.height = 0; //$(window).height();
				query = query.replace(/&width=[01-9]+&height=[^&]+/, '');
				if (group === 'project' || group === 'alert') ico = 'ico_project_big';
				if (group === 'notitle' || group === 'nohead' || group === 'dateend') title = '';

				if (ico) title = '<span class="ico ico_tb_big ' + ico + '"></span>' + title;

				self.future_title = 'no';
				if (!self.obj_window.find(".modal__header").length) {
					if (params['modal'] !== "true" && !self.is_fullpage()) {//ajax no modal
						let header = $('<div />').attr('class', 'modal__header flex_row' + ((group === 'news' || group === 'time') ? ' tb' + group : '')).appendTo(self.obj_window);
						$('<div />').attr('class', 'in flex_row').html(title).appendTo(header);
						$('<div />').attr('class', 'flex_gap').appendTo(header);

						$('<ws-btn name="btn btn-' + (group === 'invite' || group === 'profile' ? '40' : '36')+ ' btn-g btn-fill modal__closeButton" right-icon="close"></ws-btn>').bind('click', function() {
							self.hide({force: true, by_user: true});
						}).appendTo(self.obj_window.find('.modal__header'));
						$('<div />').attr('class', 'modal__content flex_column').appendTo(self.obj_window);
					} else { //ajax modal
						self.obj_overlay.unbind();
						$('<div />').attr('class', 'modal__content flex_column').appendTo(self.obj_window);
					}
				} else { //this means the window is already up, we are just loading new content via ajax
					self.obj_window.find(".modal__content").scrollTop(0);
					self.future_title = title;
				}

				self.helper_set_window_type(group);

				if (url.indexOf('modal=') !== -1 || url.indexOf('project_view') !== -1) self.obj_window.addClass('tb_task'); else self.obj_window.removeClass('tb_task');


				self.is_rdy = false;
				if (force_html) {
					if (force_html.indexOf('<html xmlns="http://www.w3.org/1999/xhtml">') !== -1) { // Some redirect happens
						self.hide();
						return false;
					}
					if (self.future_title !== 'no') self.obj_window.find(".modal__header > .in").html(self.future_title);
					self.obj_window.find(".modal__content").html(force_html);
					if ($(window).width() <= APP_SCREEN_THRESHOLD) {
						if (!self.obj_window.find('.modal__swipe').length) self.obj_window.prepend('<div class="modal__swipe"></div>');
					}
					self.check_for_alert_in_content();
					if (self.obj_hold_delete) {
						if ($(window).width() <= APP_SCREEN_THRESHOLD) {
							if (self.obj_hold_delete.hasClass('modal-fullscreen')) self.obj_window.addClass('modal-fullscreen');
							else self.obj_window.css('top', self.obj_hold_delete.css('top'));
						}
						self.remove_obj_hold_delete();
						self.obj_window.css({display: 'flex'});
					} else {
						self.obj_window.css({display: 'flex'});
					}
					self.init();
					if (data.onload) data.onload.call(self.obj_window, self.obj_window[0]);
					if (data.onreload) data.onreload.call(self.obj_window, self.obj_window[0]);
					self.is_rdy = true;
					self.update_size();
					data.resized?.call(self.obj_window, self.obj_window[0]);
					return false;
				} else {
					self.obj_window.find('.modal__header .tree').remove();
					$('.remove_with_modal').remove();

					App.core.async_task.abort('modal_show');
					App.controls.loader.start();
					self.window.loading();
					if (self.obj_hold_delete) self.obj_hold_delete.addClass('loading');

					if (post_data && Object.keys(post_data).length) {
						const post_query = Object.entries(post_data)
							.map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
							.join('&');
						query = `${query}&${post_query}`;
					}

					let url_except_query = url.replace(/\?.*/, '');
					let do_post = url.length > 1000 || post;
					if (do_post && params['action']) url_except_query += '?action=' + params['action'];
					App.core.async_task.ajax({
						id: 'modal_show',
						type: do_post ? "POST" : "GET",
						url: url_except_query,
						data: query,
						dataType: 'html',
						headers: {'x-load-type': 'modal', 'x-modal-level': self.layer_level - 1},
						success: function (html, status, xhr) {
							if (success) success.call();
							if (html.indexOf('<html xmlns="http://www.w3.org/1999/xhtml">') !== -1) { // Some redirect happens
								self.hide();
								return false;
							}
							if (!self.is_shown()) return false;
							if (xhr.getResponseHeader("X-Modal-fullpage")) {
								self.obj_window.addClass('modal-fullpage');
								self.obj_window.addClass('modal-fullscreen');  // щоб наслідувати поведінку
							}
							if (xhr.getResponseHeader("X-Modal-width")) {
								self.width = xhr.getResponseHeader("X-Modal-width");
							}
							if (xhr.getResponseHeader("X-Modal-group")) {
								self.helper_set_window_type(xhr.getResponseHeader("X-Modal-group"));
							}
							if (xhr.getResponseHeader("X-Modal-color")) {
								self.obj_window.attr('data-color', xhr.getResponseHeader("X-Modal-color"));
							} else {
								self.obj_window.removeAttr('data-color');
							}
							if (xhr.getResponseHeader("X-Modal-class")) {
								self.obj_window.addClass(xhr.getResponseHeader("X-Modal-class"));
							}
							if (xhr.getResponseHeader("X-Modal-dock")) {
								self.obj_overlay.attr('data-dock', xhr.getResponseHeader("X-Modal-dock"));
							} else {
								self.obj_overlay.removeAttr('data-dock');
							}
							if (xhr.getResponseHeader("X-Modal-title")) {
								self.obj_window.find('.modal__header > .in').html('').append(decodeURIComponent(xhr.getResponseHeader("X-Modal-title")));
							} else if (self.future_title !== 'no') self.obj_window.find(".modal__header > .in").html(self.future_title);
							self.obj_window.find(".modal__content").html(html);
							if ($(window).width() <= APP_SCREEN_THRESHOLD && !self.is_fullpage()) {
								if (!self.obj_window.find('.modal__swipe').length) self.obj_window.prepend('<div class="modal__swipe"></div>');
							}
							self.check_for_alert_in_content();
							if (self.obj_hold_delete) {
								if ($(window).width() <= APP_SCREEN_THRESHOLD) {
									if (self.obj_hold_delete.hasClass('modal-fullscreen')) self.obj_window.addClass('modal-fullscreen');
									else self.obj_window.css('top', self.obj_hold_delete.css('top'));
								}
								self.remove_obj_hold_delete();
								self.obj_window.css({display: 'flex'});
							} else {
								self.obj_window.css({display: 'flex'});
							}
							self.init();
							if (data.onload) data.onload.call(self.obj_window, self.obj_window[0]);
							if (data.onreload) data.onreload.call(self.obj_window, self.obj_window[0]);
							self.is_rdy = true;
							self.update_size();
							data.resized?.call(self.obj_window, self.obj_window[0]);
							if ("ResizeObserver" in window) {
								let observer_handler = App.helper.debounce((entries) => {
									for (const entry of entries) {
										let el = entry.target;
										let w = el.clientWidth;
										let h = el.clientHeight;
										if (!el.observed_size || el.observed_size.w !== h || el.observed_size.w !== h) {
											el.observed_size = {w, h};
											self.update_size();
											data.resized?.call(self.obj_window, self.obj_window[0]);
											data.resizedObserve?.call(self.obj_window, self.obj_window[0]);
										}
									}
								});
								let observer = new ResizeObserver(observer_handler);
								observer.observe(self.obj_window.get(0));
								self.obj_window.data('observer', observer);
							}
						},
					}).catch(function () {
						self.window.loadFailed();
					}).finally(function () {
						App.controls.loader.stop();
						if (self.obj_hold_delete) self.obj_hold_delete.removeClass('loading');
					});
				}
			}
			$(document).unbind('keydown', self.onkeydown).unbind('keyup', self.onkeyup)
				.bind('keydown', self.onkeydown).bind('keyup', self.onkeyup);
		},
		on_overlay_click: function(e) {
			if (self.dismissible && $(e.target).hasClass('modal__overlay') && !App.helper.selection.is_not_empty() && !App.click_listener.is_moved(e)) {
				self.hide();
			}
		},

		hide_callback: null,
		call_hide_callback: function() {
			self.obj_window.trigger('hidden.modal');
			if (self.hide_callback) {
				self.hide_callback();
				self.hide_callback = null;
			}
		},

		replace: function (params) {
			App.modal.hide({ immediate: true });
			App.modal.show(params);
		},

		applause_onhide: false,
		applause_inprogress: false,
		hide: function (config) {

			if (self.debug) {
				console.trace('modal', 'hide', config);
			}

			config ||= {}
			if (!self.obj_window || !self.layer_level) return false;
			if (!config.force && App.controls.editblock.has_unsaved_updates()) {
				if (config.from_popstate) App.core.history?.mobile?.push('modal');
				App.controls.editblock.show_close_alert();
				return false;
			}

			App.core.async_task.abort('modal_show');

			if (self.layer_level == 1) self.window.closing(config);
			self.obj_window.hook_hide();
			self.obj_window.trigger('before_hide.modal', [config.by_user]);
			App.bus.app.emit('modal_closing');

			if (document.location.hash.includes('#project') && self.layer_level == 1) {
				document.location.hash = '';
			}
			self.applause_onhide = config.applause && !App.device.is_mobile();
			if (config.callback) self.hide_callback = config.callback;
			if (config.hide_all) {
				self.remove_history_dom_to_level(1);
				self.layer_level = 0;
			} else if (config.nohistory) {
				self.clear_history();
				self.layer_level = 0;
			} else {
				self.layer_level--;
			}
			$.ajaxSetup({headers: {'x-load-type': 'ajax', 'x-modal-level': self.layer_level}});
			//TODO: migrate from $.ajax to own

			// App.classes.ajax.getInstance().setDefaults({
			// 	headers: {
			// 		...App.classes.ajax.getInstance().current.headers,
			// 		'x-modal-level': self.layer_level
			// 	}
			// })

			if (self.layer_level > 0) {
				if (self.history_dom[self.layer_level].allow_restore) {

					const layer_level = self.layer_level, restore_history_dom = function () {
						self.restore_history_dom(layer_level);
						self.dismissible = self.history_data[layer_level].data.dismissible ?? true;
					};

					if ($(window).width() > APP_SCREEN_THRESHOLD && !config.immediate) setTimeout(restore_history_dom, 300);
					else restore_history_dom(self.layer_level);

					self.call_hide_callback();

					App.core.history?.mobile?.back_on_hide('modal');
					return false;
				}
			}
			if (!self.layer_level) {
				$('body').removeClass('withModal withImagePreview withModal__previewPanel');
				if (config.immediate) $('body').removeClass('withModalAndTask withModalAndTaskDraft'); else {
					setTimeout(function () {
						$('body').removeClass('withModalAndTask withModalAndTaskDraft');
					}, 500);
				}
				$(window).scrollTop(self.saved_scroll_pos);
			}
			if (!config.from_popstate) App.core.history?.mobile?.back_on_hide('modal');
			if (!config.just_remove) {
				self.shown = false;
			}
			self.destroy_scroll_zones();

			$(document).unbind('keydown', self.onkeydown);
			$(document).unbind('keyup', self.onkeyup);
			$('.remove_with_modal').remove();
			$('#preview_place').hide();
			$(document).trigger('modal_onunload');

			const video = self.obj_window.find('#modal__previewVideo video').get(0);
			if (video) {
				video.pause();
				video.src = '';
				video.load();
			}

			if ($(window).width() > APP_SCREEN_THRESHOLD) {
				let func = function () {
					self.obj_window.add('#modal__previewPanel,#modal__previewImage').trigger("unload").unbind().remove();
					//if (!self.layer_level) {
					if ($('#applause i').text() && self.applause_onhide) {
						self.applause_inprogress = true;
						App.effects.applause(function () {
							$('#applause i').html('');
							self.hide_overlay();
							self.applause_inprogress = false;
							self.call_hide_callback();
						});
					} else {
						self.hide_overlay();
						self.call_hide_callback();
					}
					//} else self.hide_overlay();
					if (self.layer_level > 0) {
						self.obj_window = self.history_dom[self.layer_level].window;
						self.obj_overlay = self.history_dom[self.layer_level].overlay;
					}
				};
				if (config.immediate) func(); else setTimeout(func, 300);
			} else {
				self.obj_window.trigger("unload").unbind();
				if (self.obj_overlay.hasClass('modal__overlay-withPanel') || config.immediate) self.obj_window.removeWithComponents();
				else self.obj_window.removeClass('modal-fullscreen').css('top', '').css('max-height', '100%').removeAttr('data-top').eachDelayed(function () {
					$(this).removeWithComponents();
				}, 300);
				$('#modal__previewPanel,#modal__previewImage').trigger("unload").unbind().removeWithComponents();
				self.hide_overlay();
				self.call_hide_callback();
				if (self.layer_level > 0) {
					self.obj_window = self.history_dom[self.layer_level].window;
					self.obj_overlay = self.history_dom[self.layer_level].overlay;
				}
			}

			if (config.just_remove) return false;

			if (self.layer_level > 0) {
				self.restore_history_data(self.layer_level, !!config.back);
				return false;
			} else {
				self.clear_history();
			}
			return false;
		},

		hide_overlay: function() {
			if (!self.obj_overlay) return;
			if ($(window).width() <= APP_SCREEN_THRESHOLD) {
				self.obj_overlay.css('pointer-events', 'none').eachDelayed(function() { $(this).remove(); }, 300);
			} else self.obj_overlay.remove();
			self.obj_overlay = null;
		},
		init: function () {
			self.obj_window.find('.scrollZone').each(function () {
				if (this.scrollBars) this.scrollBars.destroy();
			});

			setTimeout(self.obj_window.hook_show, 1);

			let h_content = self.obj_window.find("#modal__headerContent");
			if (h_content.length) {
				self.obj_window.find('.modal__header > .in').html('').append(h_content.contents());
				self.obj_window.find('.modal__header > .in .tree').prependTo(self.obj_window.find('.modal__header'));
				if (h_content.is('[data-has-tabs]')) self.obj_window.find('.modal__header').addClass('modal__header-withTabs');
				if (h_content.is('[data-has-bottom-shadow]')) self.obj_window.find('.modal__header').addClass('modal__header-withShadow');
				if (h_content.is('[data-has-search]')) self.obj_window.find('.modal__header').addClass('modal__header-withSearch');
				if (h_content.is('[data-center]')) self.obj_window.find('.modal__header').addClass('modal__header-center');
				if (h_content.is('[data-force-center]')) self.obj_window.find('.modal__header').addClass('modal__header-forceCenter');
				if (h_content.is('[data-mobile-wrap]')) self.obj_window.find('.modal__header').addClass('modal__header-mobileWrap');
				if (h_content.is('[data-mobile-center]')) self.obj_window.find('.modal__header').addClass('modal__header-mobileCenter');
				h_content.remove();
			}

			let h_before = self.obj_window.find('#modal__headerBefore');
			if (h_before.length) {
				self.obj_window.find('.modal__header > .in').before(h_before.contents());
				h_before.remove();
			}

			let h_after = self.obj_window.find('#modal__headerAfter');
			if (h_after.length) {
				self.obj_window.find('.modal__header > .in').after(h_after.contents());
				h_after.remove();
			}

			let h_end = self.obj_window.find('#modal__headerEnd');
			if (h_end.length) {
				self.obj_window.find('.modal__header > *:last-child').before(h_end.contents());
				h_end.remove();
			}

			// MODAL TABS INIT + ACTIVE-TAB
			if (self.obj_window.find('.modal__tabs').length) {
				self.obj_window.find('.modal__header').after(self.obj_window.find('.modal__tabs'));
				if (self.tab) {
					self.obj_window.find('.modal__tabs__item').removeClass('active');
					self.obj_window.find('.modal__tabs__item[data-type="' + self.tab + '"]').addClass('active');

					let active_tab = self.obj_window.find('.modal__tabs__item.active');
					active_tab.scrollIntoViewIfNeededX({
						container: self.obj_window.find('.modal__tabs'),
						offset_inline: 24,
					});
				}

				let active_tab = self.obj_window.find('.modal__tabs__item.active');
				if (active_tab.length && active_tab.attr('data-load')) {
					$.ajax({
						url: active_tab.attr('data-load'),
						success: function (html) {
							self.obj_window.find('.modal__content__cap').hide();
							self.obj_window.find('.modal__content').append(html);
							self.check_for_alert_in_content();
							self.obj_window.css({display: 'flex'});
							self.is_rdy = true;
							self.update_size();
						},
					});
				}
			} else if (self.obj_window.find('.modal__header__tabs, .mobile-head__tabs').length) {
				if (self.tab) {
					self.obj_window.find('.modal__header__tabs, .mobile-head__tabs').find('a[data-type="' + self.tab + '"]').first().trigger('click');
				}
			}
			self.obj_window.find('.modal__content > form').addClass('flex_column flex_content');

			// MODAL MENU INIT
			if (self.obj_window.find('.modal__headerMenu').length) {
				self.obj_window.find('.modal__header').after(self.obj_window.find('.modal__headerMenu'));
			}

			$(document).trigger('page_onload.once').unbind('page_onload.once');

			if (!$('body').hasClass('login')) {
				$('#applause i').html($('#applause_text').length ? $('#applause_text').val() : '');

				if (self.obj_window.find('#modal__backButton').length) self.obj_window.find('.modal__header').prepend($("#modal__backButton"));
				if (self.obj_window.find('#modal__header__avatar').length) self.obj_window.find('.modal__header').prepend($("#modal__header__avatar"));
				if (self.obj_window.find(".modal__content .modal_user_select .quick_search, .modal__content .quick_search-modal").length) {
					self.obj_window.find('.modal__header > .in').wrapInner("<font class='vs_search'></font>");
					self.obj_window.find(".modal__content .modal_user_select .quick_search, .modal__content .quick_search-modal").appendTo(self.obj_window.find('.modal__header > .in'));
				}
				App.controls.slider.init();

				$(document).trigger('modal_onload.once').unbind('modal_onload.once');
				$(document).trigger('modal_onload.everytime');
				$(document).trigger('modal_onreload.once').unbind('modal_onreload.once');

				App.controls.code_highlight.init();
				self.obj_window.find('.modal__content .st_highlight').blink();

				self.obj_window.find('.menu-inModal .scrollZone').not('.scrollZone-remain').children().unwrap();
				self.obj_window.find('.menu:not(.menu-inModal)').filter(function() {
					return !$(this).closest('.menu__submenuWrapper').length;
				}).addClass('remove_with_modal').appendTo('#modalContainer');

				self.obj_window.find('.modal__dataTable .modal__dataTable__item').bind('click', function (e) {
					if (!$(e.target).parents().addBack().filter('a, input, label').length && $(this).find('input[type=checkbox], input[type=radio]').length) {
						$(this).find('input[type=checkbox], input[type=radio]').trigger('click').each(function () {
							if (this.onclick) this.onclick();
						});
						return false;
					}
				});
			}

			const _init = () => {
				self.obj_window.css('opacity', '').css('scale', '').css('transition', '');

				if (App.modal.obj_window.attr('data-group') !== 'profile') {
					self.init_scroll_zones();
					self.obj_window.find('.scrollZone').each(App.scroll_listener.onDivScroll);
				}

				self.obj_window.find('.modal__title__search input, .modal .editBlock__picker__search input').focus();

				self.obj_window.find('input[autofocus]').focus_to_end();
				self.obj_window.trigger('transitionend');
			}

			if (self.obj_window.use_show_animation) {
				setTimeout(_init, 155);
			} else {
				_init();
			}
		},

		init_panel: function () {
			let panel = $('#modal__previewPanel');
			if (panel.hasClass('ws_init')) {

			} else {
				panel.addClass('ws_init').appendTo(self.obj_overlay);
				App.helper.nextTick(() => {
					$('body').addClass('withModal__previewPanel');
				});

				panel.children('.links').each(function (_, links) {
					const $links = $(links);
					const $file_central_btn = $links.find('#file_central_btn');
					if (!$file_central_btn) return;
					$left = $file_central_btn.prevAll().uniqueSort();
					$right = $file_central_btn.nextAll();
					$file_central_btn.wrapAll('<div class="links__center"></div>');
					$left.wrapAll('<div class="links__left"></div>');
					$right.wrapAll('<div class="links__right"></div>');
					$links.addClass('links--grid');
				});

				App.helper.nextTick(() => {
					const overlayEl = self.obj_overlay?.get(0);
					if (!overlayEl || overlayEl._preview_ps_observed) return;

					overlayEl._preview_ps_observed = true;
					self.init_preview_scroll_zone(overlayEl);

					new MutationObserver(() => {
						self.init_preview_scroll_zone(overlayEl);
					}).observe(overlayEl, { childList: true, subtree: true });
				});

				if (!$('body').hasClass('mobile')) $('#google_data .sw_pre a').hover(function () {
					$(this).parent().addClass('sw_hover');
				}, function () {
					$(this).parent().removeClass('sw_hover');
				});
				self.panel.current_index = 0;
				self.update_files_panel();
				panel.find('.prev').click(function (e) {
					panel.find('.next').show();
					panel.find('.more_next').hide();
					if (self.swipe_end) {
						panel.find('#files_new').removeClass('ani_panel');
						self.swipe_end = false;
						self.panel.current_index = 0;
					} else {
						panel.find('#files_new').addClass('ani_panel');
						self.panel.current_index -= Math.min(3, Math.max(self.panel.item_max_fitin, 1));
						if (self.panel.current_index < 0) self.panel.current_index = 0;
					}
					if (self.panel.current_index === 0) {
						panel.find('.prev').hide();
						panel.find('.more_prev').hide();
					}
					panel.find('#files_new').css({marginLeft: (-self.panel.current_index * self.panel.item_width) - 2});
					if (self.panel.item_max_fitin === 1 && e.originalEvent) {
						panel.find('#files_new .fileItem-active').prev().click();
					}
					return false;
				});
				panel.find('.next').click(function (e) {
					if (self.swipe_end) {
						panel.find('#files_new').removeClass('ani_panel');
						self.swipe_end = false;
						self.panel.current_index = self.panel.item_count - self.panel.item_max_fitin;
					} else {
						panel.find('#files_new').addClass('ani_panel');
						self.panel.current_index += Math.min(3, Math.max(self.panel.item_max_fitin, 1));
						if (self.panel.current_index > self.panel.item_count - self.panel.item_max_fitin) self.panel.current_index = self.panel.item_count - self.panel.item_max_fitin;
					}
					panel.find('.prev').show();
					panel.find('.more_prev').hide();
					if (self.panel.current_index === self.panel.item_count - self.panel.item_max_fitin) {
						panel.find('.next').hide();
						panel.find('.more_next').show();
					}
					panel.find('#files_new').css({marginLeft: (-self.panel.current_index * self.panel.item_width) - 2});
					if (self.panel.item_max_fitin === 1 && e.originalEvent) {
						panel.find('#files_new .fileItem-active').next().click();
					}
					return false;
				});

				/**
				 * ----- Seems to be unused -----
				 */

				panel.find('.more_prev').click(function () {
					panel.find('.loading_space_prev').load($(this).attr('rel'), function () {
						self.panel.current_index += panel.find('.loading_space_prev .fileItem').length;
						panel.find('.loading_space_prev .fileItem').insertAfter(panel.find('.loading_space_prev'));
						panel.find('.loading_space_prev').remove();
						self.update_files_panel(true);
					});
					$(this).remove();
					return false;
				});
				panel.find('.more_next').click(function () {
					panel.find('.loading_space_next').load($(this).attr('rel'), function () {
						panel.find('.loading_space_next .fileItem').insertAfter(panel.find('.loading_space_next'));
						panel.find('.loading_space_next').remove();
						self.update_files_panel(true);
					});
					$(this).remove();
					return false;
				});
			}
		},

		update_size: function (smooth) {
			if (!self.is_shown() || !self.is_rdy || self.obj_window.hasClass('swype') || self.obj_window.hasClass('modal-fullscreen')) return;
			if (typeof smooth === 'undefined') smooth = 0;
			if ($('#modal__previewFrame').length || $('#google_view_accept').length || $('#modal__previewVideo').length || $('#modal__previewAudio').length || $('#modal__alert').length) {
				if ($(window).width() <= APP_SCREEN_THRESHOLD) {
					$(window).scrollTop(0);
				}
				return;
			}
			if ($(window).width() <= APP_SCREEN_THRESHOLD) {
				if (self.obj_window.outerHeight() > 0.7 * $(window).height()) self.obj_window.addClass('modal-fullscreen').css({top: ''});
				else self.obj_window.css({top: $(window).height() - self.obj_window.outerHeight()});
			} else {
				self.obj_window.css({
					width: self.width,
					maxHeight: 'min(' + Math.floor(self.width * 1.5) + 'px, 100% - 40px)'
				});
			}
		},

		update_image_size: function () {
			const panel_height = ($('#modal__previewPanel').outerHeight() ?? 0);
			const offset_top = Math.floor(panel_height / 2);
			let max_image_width = self.window_width - 40;
			let max_image_height = self.window_height - panel_height - 60;
			let pix_image_width, pix_image_height;
			pix_image_width = self.image_width / window.devicePixelRatio;
			pix_image_height = self.image_height / window.devicePixelRatio;

			let image = $('#modal__previewImage');
			let $zoom_btn = $('#file_central_btn');
			let $zoom_data = $zoom_btn.find('#zoom_data');

			$zoom_btn.attr('onclick', 'App.modal.toggle_image_zoom(); return false').show();

			if (pix_image_width <= max_image_width && pix_image_height <= max_image_height) {
				// enough space
				$zoom_btn.css({ pointerEvents: 'none' });
				image.removeClass('zoom_out').removeClass('zoom_in').css({
					width: pix_image_width,
					height: pix_image_height,
					marginTop: -(offset_top + Math.floor(pix_image_height / 2)),
					marginLeft: -Math.floor(pix_image_width / 2)
				});
				$zoom_data.html(self.image_width + ' × ' + self.image_height + '&nbsp;&nbsp;|&nbsp;&nbsp;100 %');
			} else {
				$zoom_btn.css({ pointerEvents: '' });
				// not enough space - use zoom-in/zoom-out
				if (max_image_height / self.image_height < max_image_width / self.image_width) {
					self.current_image_width = Math.floor(self.image_width * max_image_height / self.image_height);
					self.current_image_height = max_image_height;
				} else {
					self.current_image_height = Math.floor(self.image_height * max_image_width / self.image_width);
					self.current_image_width = max_image_width;
				}

				self.current_image_height = self.current_image_height * window.devicePixelRatio;
				self.current_image_width = self.current_image_width * window.devicePixelRatio;

				if (image.hasClass('zoom_in')) {
					image.css({
						width: pix_image_width,
						height: pix_image_height,
						marginTop: -(offset_top + Math.floor(pix_image_height / 2)),
						marginLeft: -(Math.floor(pix_image_width / 2))
					});
					$zoom_data.html(self.image_width + ' × ' + self.image_height + '&nbsp;&nbsp;|&nbsp;&nbsp;' + Math.floor(100 * self.current_image_width * window.devicePixelRatio / self.image_width) + ' %');
				} else {
					image.addClass('zoom_out');
					pix_image_width = self.current_image_width / window.devicePixelRatio;
					pix_image_height = self.current_image_height / window.devicePixelRatio;

					image.css({
						width: pix_image_width,
						height: pix_image_height,
						marginTop: -(offset_top + Math.floor(pix_image_height / 2)),
						marginLeft: -Math.floor(pix_image_width / 2)
					});
					$zoom_data.html(self.image_width + ' × ' + self.image_height + '&nbsp;&nbsp;|&nbsp;&nbsp;' + Math.floor(100 * pix_image_width * window.devicePixelRatio / self.image_width) + ' %');
				}
			}
		},

		toggle_image_zoom: function (point) {
			if (App.swipe.type !== null) return;
			const panel_height = ($('#modal__previewPanel').outerHeight() ?? 0);
			const offset_top = Math.floor(panel_height / 2);
			let current_margin_left, current_margin_top, pix_image_width, pix_image_height, offset;
			let image = $('#modal__previewImage');
			let $zoom_data = $('#zoom_data');

			if (image.hasClass('zoom_in-move')) return;

			if (image.hasClass('zoom_free')) {
				self.preview_image.resetZoom();
				if (image.hasClass('zoom_in')) image.removeClass().addClass('zoom_out');
				self.update_image_size();
				return;
			}

			if (image.hasClass('zoom_no')) {
				image.removeClass('zoom_no');
			} else if (image.hasClass('zoom_out')) {
				pix_image_width = self.image_width / window.devicePixelRatio;
				pix_image_height = self.image_height / window.devicePixelRatio;
				current_margin_left = Math.floor(pix_image_width / 2)*-1;
				current_margin_top = Math.floor(pix_image_height / 2)*-1;

				if (point != null) {
					let CENTER_ZONE = 0.33, EDGE_ZONE = 0.33;
					let img_rect = { left: image.get(0).offsetLeft, top: image.get(0).offsetTop, w: image.get(0).offsetWidth, h: image.get(0).offsetHeight };
					let factor = Math.min(img_rect.w/pix_image_width, img_rect.h/pix_image_height);
					let zoom_vector = { x: point.x - img_rect.left - img_rect.w/2, y: point.y - img_rect.top - img_rect.h/2 };

					if (Math.abs(zoom_vector.x) > img_rect.w*CENTER_ZONE/2 || Math.abs(zoom_vector.y) > img_rect.h*CENTER_ZONE/2) {

						if (Math.abs(zoom_vector.x)/(img_rect.w/2) > 1-EDGE_ZONE) zoom_vector.x = Math.sign(zoom_vector.x) * img_rect.w/2;
						if (Math.abs(zoom_vector.y)/(img_rect.h/2) > 1-EDGE_ZONE) zoom_vector.y = Math.sign(zoom_vector.y) * img_rect.h/2;

						current_margin_left -= zoom_vector.x/factor;
						current_margin_top -= zoom_vector.y/factor;

						current_margin_left += zoom_vector.x;
						current_margin_top += zoom_vector.y - $('#modal__previewPanel').height()/2;
					}
				}

				image.removeClass('zoom_out').addClass('zoom_in').addClass('item_ania').css({
					width: pix_image_width,
					height: pix_image_height,
					marginTop: current_margin_top,
					marginLeft: current_margin_left
				}).eachDelayed(function () {
					$(this).removeClass('item_ania');
				}, 500);
				$zoom_data.html(self.image_width + ' × ' + self.image_height + '&nbsp;&nbsp;|&nbsp;&nbsp;' + Math.floor(100 * pix_image_width * window.devicePixelRatio / self.image_width) + ' %');
			} else if (image.hasClass('zoom_in')) {
				pix_image_width = self.current_image_width / window.devicePixelRatio;
				pix_image_height = self.current_image_height / window.devicePixelRatio;

				image.removeClass('zoom_in').addClass('zoom_out').addClass('item_ania').css({
					width: pix_image_width,
					height: pix_image_height,
					marginTop: -(offset_top + Math.floor(pix_image_height / 2)),
					marginLeft: -Math.floor(pix_image_width / 2)
				}).eachDelayed(function () {
					$(this).removeClass('item_ania');
				}, 500);
				$zoom_data.html(self.image_width + ' × ' + self.image_height + '&nbsp;&nbsp;|&nbsp;&nbsp;' +  Math.floor(100 * pix_image_width * window.devicePixelRatio / self.image_width) + ' %');
			}
		},

		preview_image: {

			onGestureOptions: {

				onBefore: function (e) {
					if (e.some('#modal__previewImage')) return;
					e.cancel = true;
				},

				onGestureStart: function(e) {
					const $img = $('#modal__previewImage');

					let data = $img.data('fz');
					if (!data) {
						data = {
							pan_x: 0,
							pan_y: 0,
							current_scale: 1,
						};
						$img.data('fz', data);
					}

					// Фіксуємо початкові параметри жесту
					data.gesture_start_scale = data.current_scale;
					data.gesture_start_pan_x = data.pan_x;
					data.gesture_start_pan_y = data.pan_y;

					// Зберігаємо стартову точку для пану
					if (e && e.point) {
						data.gesture_start_point_x = e.point.x;
						data.gesture_start_point_y = e.point.y;
					}

					$img.data('fz', data);
				},

				onZoom: function(e) {
					const $img = $('#modal__previewImage');
					const data = $img.data('fz');
					if (!data) return;

					$img.addClass('zoom_free');

					// новий scale = початковий масштаб жесту * scale події
					const new_scale = data.gesture_start_scale * e.scale;

					// якщо є pan gesture
					let pan_x = data.gesture_start_pan_x;
					let pan_y = data.gesture_start_pan_y;
					if (e.point) {
						pan_x += e.point.x - data.gesture_start_point_x;
						pan_y += e.point.y - data.gesture_start_point_y;
					}

					self.preview_image.applyZoom(new_scale, pan_x, pan_y);
				},

				onGestureEnd: function(e) {
					const $img = $('#modal__previewImage');
					const data = $img.data('fz');
					if (!data) return;
					// може краще буде тут обмежити min/max
				},
			},

			// імітація жесту
			debugZoom: function (dir = 'in') {
				const gesture = self.preview_image.onGestureOptions;

				gesture.onGestureStart({ point: { x: 100, y: 100 } });

				let scale = 1;
				const targetScale = dir === 'in' ? 1.6 : 0.6;
				const steps = 12;
				const interval = 100;

				let currentStep = 0;
				const zoomInterval = setInterval(() => {
					currentStep++;
					scale = 1 + ((targetScale - 1) * currentStep / steps);
					gesture.onZoom({ scale });

					if (currentStep >= steps) {
						clearInterval(zoomInterval);
						gesture.onGestureEnd({ scale });
					}
				}, interval);
			},

			applyZoom: function (scale, pan_x, pan_y) {
				const $img = $('#modal__previewImage');
				const MIN_SCALE = 0.5;
				const MAX_SCALE = 4;

				// обмежуємо scale
				scale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, scale));

				// обмежити pan?
				// const rect = $img.get(0).getBoundingClientRect();
				// pan_x = clamp(pan_x, minX, maxX);
				// pan_y = clamp(pan_y, minY, maxY);

				const data = $img.data('fz');
				data.current_scale = scale;
				data.pan_x = pan_x;
				data.pan_y = pan_y;

				$img.css({
					'--pan-x': `${pan_x}px`,
					'--pan-y': `${pan_y}px`,
					'--scale': `${scale}`,
				});

				// відображаємо %
				const pix_image_width = $img.width();
				const base_percent = Math.floor(100 * pix_image_width * window.devicePixelRatio / self.image_width);
				const percent = Math.round(base_percent * scale);
				$('#zoom_data').html(`${self.image_width} × ${self.image_height}&nbsp;&nbsp;|&nbsp;&nbsp;${percent} %`);
			},

			resetZoom: function () {
				const $img = $('#modal__previewImage');
				$img.removeData('fz');
				$img.css({
					'--pan-x': '',
					'--pan-y': '',
					'--scale': '',
				});
				$img.removeClass('zoom_free');
			},
		},

		panel: {
			item_width: 226,
			item_count: 0,
			item_max_fitin: 3,
			current_index: 0,
		},

		update_files_panel: function (no_repos) {
			let panel = $('#modal__previewPanel');
			self.panel.item_max_fitin = Math.floor((self.window_width - 60) / self.panel.item_width);
			self.panel.item_count = panel.find('.fileItem').length;
			panel.find('.prev').hide();
			panel.find('.next').hide();
			panel.find('.more_prev').hide();
			panel.find('.more_next').hide()
			if (self.panel.item_count <= self.panel.item_max_fitin) {
				self.panel.item_max_fitin = self.panel.item_count;
				panel.find('.more_prev').show();
				panel.find('.more_next').show()
			} else {
				if (!no_repos) {
					self.panel.current_index = 0;
					let tb_i = 0;
					panel.find('.fileItem').each(function () {
						if ($(this).hasClass('fileItem-active')) self.panel.current_index = tb_i;
						tb_i++;
					});
					if (self.panel.item_max_fitin > 2) self.panel.current_index -= Math.floor(self.panel.item_max_fitin / 2);
				}
				if (self.panel.current_index > 0) panel.find('.prev').show(); else panel.find('.more_prev').show();
				if (self.panel.current_index < self.panel.item_count - self.panel.item_max_fitin) panel.find('.next').show(); else panel.find('.more_next').show();
			}
			let dots_width = 60;
			if (self.window_width <= APP_SCREEN_THRESHOLD) dots_width = 40;
			panel.find('.more_prev').css({left: Math.floor((self.window_width - self.panel.item_width * self.panel.item_max_fitin) / 2 - dots_width)});
			panel.find('.more_next').css({right: Math.floor((self.window_width - self.panel.item_width * self.panel.item_max_fitin) / 2 - dots_width)});
			panel.find('#files_panel_').css({width: (self.panel.item_width * self.panel.item_max_fitin) + 2});
			if (self.panel.current_index < 0) self.panel.current_index = 0;
			if (self.panel.current_index > self.panel.item_count - self.panel.item_max_fitin) self.panel.current_index = self.panel.item_count - self.panel.item_max_fitin;
			panel.find('#files_new').css({marginLeft: (-self.panel.current_index * self.panel.item_width - 2)});
			panel.find('a.thickbox').not('.ws_init').addClass('ws_init').bind('click',  function () {
				panel.find('.fileItem').removeClass('fileItem-active').addClass('zoom_in');
				$(this).closest('.fileItem').addClass('fileItem-active').removeClass('zoom_in');
			}).each(function () {
				if (this.href.indexOf('nopanel') === -1) $(this).attr('href', this.href + '?nopanel=1');
			});

			panel.on('click', '.fileItem.zoom_in', function (e) {
				const target = $(e.target);

				if ((target.is('div, span, b') && !target.parent().is('a'))) {
					$(this).find('a.thickbox:first').trigger('click');
				}
			});

		},

		saved_scroll_pos: 0,

		clear_history: function () {
			self.history_data = [];
			self.history_dom = [];
		},

		reload: function (callback) {
			let level = self.layer_level;
			let data = self.history_data[level].data;
			data.reload = true;
			data.onreload = callback;
			self.show(data);
		},

		restore_history_data: function (level, force) {
			setTimeout(function () {
				let data = self.history_data[level].data;
				data.reload = true;
				self.show(data);
			}, force ? 0 : 500);
		},

		history_data: [],
		history_save: function (data) {
			let backup = data.backup || false;
			let reload = data.reload || false;
			let group = data.group || '';
			let url = data.url || '';
			if (self.helper_validate_preview_url(url)) {
				if (url.indexOf('nopanel') !== -1) reload = true; else backup = true;
			}
			if (!self.layer_level) backup = reload = false;
			// if (!self.history_dom[self.layer_level - 1]) reload = false;
			// save = url.indexOf('modal=') !== -1 || url.indexOf('action=master') !== -1 || url.indexOf('project_view') !== -1

			// find same group
			if (group) {
				let remove_to_level = 0;
				if (self.layer_level >=1) {
					for (let i = self.layer_level; i >=1 ; i--) {
						if (self.history_data[i].data.group && self.history_data[i].data.group.indexOf(group) !== -1) remove_to_level = i; // time_add will replace time, time will open over time_add
					}
				}
				if (remove_to_level) {
					reload = true;
					backup = false;
					self.remove_history_dom_to_level(remove_to_level);
					self.layer_level = remove_to_level;
				}
			}
			if (reload) {
				self.obj_hold_delete_all.push(self.obj_window);
				self.obj_hold_delete ??= self.obj_window;
				self.obj_window = null;
				// self.obj_overlay.remove();
			} else if (backup && self.layer_level) {
				if (!self.history_data[self.layer_level]) debugger;
				self.history_data[self.layer_level].scroll = self.obj_window.find('.scrollZone').length ? self.obj_window.find('.scrollZone').scrollTop() : 0;
				self.save_history_dom(self.layer_level);
				self.layer_level++;
			} else {
				if (self.is_shown()) App.core.history?.mobile?.back_on_hide('modal');
				self.remove_history_dom();
				self.layer_level = 1;
			}
			self.history_data[self.layer_level] = {data: data, scroll: 0};
			$.ajaxSetup({headers: {'x-load-type': 'ajax', 'x-modal-level': self.layer_level}});
			//TODO: migrate from $.ajax to own

			// App.classes.ajax.getInstance().setDefaults({
			// 	headers: {
			// 		...App.classes.ajax.getInstance().current.headers,
			// 		'x-modal-level': self.layer_level
			// 	}
			// })
		},
		history_dom: [],

		remove_obj_hold_delete: function () {
			if (self.obj_hold_delete_all.length) {
				self.obj_hold_delete_all.forEach(obj => obj.removeWithComponents());
				self.obj_hold_delete_all = [];
				self.obj_hold_delete = null;
			}
		},

		add_history_classes: function() {
			for (let i = this.layer_level; i > 0 ; i--) {
				this.history_dom[i].window.attr('data-deep', this.layer_level - i);
			}
		},

		restore_history_dom: function (level) {
			self.obj_window.removeWithComponents();
			self.obj_overlay.remove();
			self.obj_window.add('#modal__previewPanel,#modal__previewImage').trigger("unload").unbind().remove();
			$('.remove_with_modal').remove();

			self.history_dom[level].dom.appendTo('#modalContainer');
			self.obj_window = self.history_dom[level].window;
			self.obj_overlay = self.history_dom[level].overlay;
			self.width = self.history_dom[level].width;
			self.height = self.history_dom[level].height;
			self.add_history_classes();
		},

		presave_history_dom: function (level) {
			self.history_dom[level] = {
				window: self.obj_window,
				overlay: self.obj_overlay,
			}
		},

		save_history_dom: function (level) {
			self.history_dom[level] = {
				window: self.obj_window,
				overlay: self.obj_overlay,
				width: self.width,
				height: self.height,
				dom: $('.remove_with_modal').hide().detach(),
				// dom: $(self.obj_window).add('.remove_with_modal').detach(),
				allow_restore: true
			}
			self.obj_window = null;
			self.obj_overlay = null;
		},

		remove_history_dom_to_level: function (level) {
			for (let i = level; i <= self.layer_level - 1; i++) {
				self.history_dom[i].window.remove();
				self.history_dom[i].overlay.remove();
				self.history_dom[i] = null;
			}
		},

		remove_history_dom: function () {
			if (self.layer_level > 1) {
				for (let i = 1; i <= self.layer_level - 1; i++) {
					self.history_dom[i].window.remove();
					self.history_dom[i].overlay.remove();
					self.history_dom[i] = null;
				}
			}
			if (self.obj_window) {
				self.obj_window.removeWithComponents();
				self.obj_window = null;
			}
		},

		invalidate_history_dom: function () {
			if (self.layer_level > 1) {
				for (let i = 1; i <= self.layer_level - 1; i++) {
					self.history_dom[i].allow_restore = false;
					self.history_dom[i].window.addClass('need_reload');
				}
			}
		},

		invalidate_history_dom_by_group: function (group) {
			if (self.is_shown()) {
				if (self.obj_window.attr('data-group') === group) self.reload(); // foreground level
				else if (self.layer_level > 1) { // background level
					for (let i = 1; i <= self.layer_level - 1; i++) if (self.history_dom[i].window.attr('data-group') === group) {
						self.history_dom[i].allow_restore = false;
						self.history_dom[i].window.addClass('need_reload');
					}
				}
			}
		},

		check_for_alert_in_content: function () {
			if ($('#modal__alert').length) {
				$('#modal__alert').appendTo(self.obj_overlay);
				self.width = $('#modal__alert').outerWidth();
				self.height = $('#modal__alert').outerHeight();
				$('#modal__alert').appendTo(self.obj_window);
				self.obj_window.find('.modal__content,.modal__header,#modal__preview').remove();
			}
		},

		helper_handle_iframe_svg_loading: function () {

			const get_svg_size = (svg) => {
				const vb = svg.viewBox?.baseVal;

				if (vb && vb.width && vb.height) {
					return {
						width: vb.width,
						height: vb.height
					};
				}

				return {
					width: svg.width.baseVal.value,
					height: svg.height.baseVal.value
				};
			};

			const container = self.obj_window.find('#modal__previewSvg');
			const iframe = container.find('iframe');
			if (!iframe.length) return;
			self.obj_window.addClass('loading');
			iframe.css({
				visibility: 'hidden',
			});
			iframe.on('load', function () {
				try {
					const svg = this.contentDocument.querySelector('svg');
					if (!svg) return;
					const { width, height } = get_svg_size(svg);

					container.css({
						width: width + 40,
						height: height + 40,
						padding: 20,
						boxSizing: 'border-box',
					});
				} finally {
					self.obj_window.removeClass('loading');
					iframe.css({
						visibility: '',
					});
				}
			});
		},

		timeout_reload_google_doc: null,
		helper_reload_google_doc: function() {
			let win = $("#modal__previewFrame").get(0);
			if (!win.contentWindow.document.body.innerHTML) $("#modal__previewFrame").attr('src', $("#modal__previewFrame").attr('src'));
		},
		init_reload_google_doc: function() {
			self.timeout_reload_google_doc = setInterval(self.helper_reload_google_doc, 2000);
			$('#modal__previewFrame').on('load', function () {
				clearInterval(self.timeout_reload_google_doc);
			});

		},

		helper_set_window_type(group) {
			self.obj_window.find('.modal__header').toggle(group !== 'nohead');
			if (group === 'users' || group === 'alert' || group === 'alert2') group = 'white';
			if (group === 'workdays') group = 'holidays';
			self.obj_window.attr('data-group', group);
		},

		init_scroll_zones: function() {
			self.obj_window.find('.scrollZone').not('.ps').each(function() {
				this.scrollBars = App.controls.js_scrollbars.init(this);
				App.helper.nextTick(() => {
					this.scrollBars.update();
					$(this).trigger('ps-ready');
				});
			});
		},

		destroy_scroll_zones: function() {
			self.obj_window.find('.scrollZone').filter(function() {
				return !$(this).closest('.menu').length;
			}).each(function() {
				if (this.scrollBars) this.scrollBars.destroy();
			});
		},

		init_preview_scroll_zone: function (root) {
			const previewEl = root.querySelector('#modal__previewFrame .scrollZone');
			if (!previewEl || previewEl.scrollBars) return;

			previewEl.scrollBars = App.controls.js_scrollbars.init(previewEl, {suppressScrollX: true, suppressScrollY: true});
			if (previewEl.scrollHeight > previewEl.clientHeight + 1) {
				previewEl.scrollBars.settings.suppressScrollY = false;
				previewEl.scrollBars.update();
			}
		},

		onimage_load_error: function () {
			if ($('#modal__alertOnError').length) {
				self.obj_window.attr('data-group', 'trans')
				$('#modal__alertOnError').attr('id', 'modal__alert');
				self.check_for_alert_in_content();
				self.obj_window.show();
				self.init();
			}
		},

		onimage_load_success: function () {
			let image = $('#modal__previewImage'), panel = $('#modal__previewPanel');

			if (!panel.hasClass('ws_init_img')) {
				panel.addClass('ws_init_img');
				image.css({visibility: 'visible', scale: 0.97, opacity: 0, transition: 'opacity 0.15s linear, scale 0.15s linear'});
				setTimeout(function () {
					image.css({scale: 1, opacity: 1});
					setTimeout(function () {
						image.css({scale: '', opacity: '', transition: ''});
					}, 200);
				}, 10);
			} else {
				image.css({visibility: 'visible'});
			}

			image.appendTo('#modalContainer').bind('click', (e) => {
				if (App.click_listener.is_moved(e)) return;
				self.toggle_image_zoom({x: e.clientX, y: e.clientY})
			});
			self.image_width = 1*image.attr('width');
			self.image_height = 1*image.attr('height');
			if (!self.image_width || !self.image_height) {
				if (image.attr('rel') && image.attr('rel') !== 'load') {
					let sizes = image.attr('rel').split('|');
					self.image_width = sizes[0];
					self.image_height = sizes[1];
				} else {
					self.image_width = image.width();
					self.image_height = image.height();
				}
			}
			self.update_image_size();
		},

		onresize: function () {
			if (self.previous_screen_width && (self.previous_screen_width !== $(window).width())) {
				if ($('#modal__previewImage').length) {
					self.panel.item_width = ($(window).width() < 360) ? 210 : 226;
					self.update_image_size();
					self.update_files_panel();
				}
				if (self.is_shown()) {
					self.update_size(-1);
				}
			}
			self.previous_screen_width = $(window).width();
		},

		onresize_viewport: function() {
			if (self.is_shown() && $(window).width() <= APP_SCREEN_THRESHOLD) {
				if (self.obj_window.hasClass('modal-fullscreen')) {
					const needs_resize = !App.menu.is_shown();
					if (needs_resize) App.modal.obj_window.css('height', App.helper.viewport.height());
				}
			}
		},

		onKeyboardShow: function() {
			if (self.is_shown() && $(window).width() <= APP_SCREEN_THRESHOLD) {
				if (!self.obj_window.hasClass('modal-fullscreen')) self.obj_window.addClass('modal-fullscreen noani swype').css({top: ''}).eachDelayed(function() {
					$(this).removeClass('noani swype');
				}, 300);
			}
		},

		onkeyup: function (e) {
			if (!self.is_shown()) return;
			let keycode = e.which || e.keyCode || e.charCode;

			if (keycode === App.keycode.Space && $('#modal__previewImage').hasClass('zoom_in-move')) {
				$('#modal__previewImage').removeClass('zoom_in-move');
				self.toggle_image_zoom();
			}
		},
		onkeydown: function (e) {
			if (!self.is_shown()) return;
			let keycode = e.which || e.keyCode || e.charCode;
			let o = $(e.target);
			let o_parents = o.parents().addBack();
			let in_input_strict = o.is('input, textarea') || o_parents.filter('.editor__data').length;
			let in_editor = (o.is('textarea') && o.val()) || (o_parents.filter('.editor__data').length && App.editor.body.html());
			let in_input = o.is('input, textarea') && (o.val() || o.attr('tabindex')) || in_editor;
			if (in_input || App.menu.is_shown()) return true;

			let anyWith = $('body').hasClass('withModalAndTaskDraft') || $('body').hasClass('withModalAndTask');
			if (anyWith && App.click_listener.pointer.closest('#modal__previewImage') == null) {
				return true;
			}

			if (keycode === App.keycode.Space) { // space
				if ($('#modal__previewImage').hasClass('zoom_in')) {
					$('#modal__previewImage').addClass('zoom_in-move');
					return false;
				}
				if ($('#modal__previewImage').hasClass('zoom_out')) {
					self.toggle_image_zoom();
					return false;
				}
			}
			if (keycode === App.keycode.Enter || (e.ctrlKey && keycode === App.keycode.ArrowDown)) { // enter
				if ($('#modal__previewPanel').length) {
					$('#modal__previewPanel .fileItem-active a').not('.thickbox').filter(':first').each(function () {
						App.core.goto(this.href);
					});
					return false;
				}
			}
			if (keycode === App.keycode.ArrowRight) { // next
				if ($('#modal__previewPanel').length) {
					if (e.ctrlKey) {
						$('#modal__previewPanel a.next:visible').trigger('click');
					} else {
						let c = $('#modal__previewPanel');
						let j = c.find('.fileItem-active').next();
						if (j.length) {
							j.find('a:first').trigger('click');
							const jRect = j[0].getBoundingClientRect();
							const cRect = c[0].getBoundingClientRect();
							if (jRect.right > cRect.right - 210) {
								c.find('a.next:visible').trigger('click');
							}
						}
					}
					return false;
				}
			}
			if (keycode === App.keycode.ArrowLeft) { // prev
				if ($('#modal__previewPanel').length) {
					if (e.ctrlKey) {
						$('#modal__previewPanel a.prev:visible').trigger('click');
					} else {
						let c = $('#modal__previewPanel');
						let j = c.find('.fileItem-active').prev();
						if (j.length) {
							j.find('a:first').trigger('click');
							let jRect = j[0].getBoundingClientRect();
							let cRect = c[0].getBoundingClientRect();
							if (jRect.left < cRect.left) {
								c.find('a.prev:visible').trigger('click');
							}
						}
					}
					return false;
				}
			}
		},

		onunload: function() {
			$(document).unbind('.modal');
			$(window).unbind('.modal');
		},

		destructor: function () {

			clearInterval(self.timeout_reload_google_doc);
			self.timeout_reload_google_doc = null;

			self.shown = false;
			self.window.closed();
			self.is_rdy = false;
			self.is_preserve = false;
			self.window_width = 0;
			self.window_height = 0;
			self.width = 0;
			self.height = 0;
			self.image_width = 0;
			self.image_height = 0;
			self.current_image_width = 0;
			self.current_image_height = 0;
			self.future_title = 'no';
			self.swipe_end = false;
			self.layer_level = 0;
			self.tab = '';
			self.dismissible = true;

			self.obj_window?.removeWithComponents();
			self.obj_overlay?.removeWithComponents();
			self.obj_params?.removeWithComponents();
			self.obj_hold_delete?.removeWithComponents();
			self.obj_hold_delete_all.forEach(obj => obj.removeWithComponents());

			self.obj_window = null;
			self.obj_overlay = null;
			self.obj_params = null;
			self.obj_hold_delete = null;
			self.obj_hold_delete_all = [];

			self.debug = false;
			self.hide_callback = null;
			self.applause_onhide = false;
			self.applause_inprogress = false;
			self.saved_scroll_pos = 0;
			self.history_data = [];
			self.history_dom = [];
		},

		onBoot: function () {
			App.bus.window
				.on('resize', App.helper.throttle(self.onresize))
				.on('resize_viewport', App.helper.throttle(self.onresize_viewport))
				.on('keyboard_show', self.onKeyboardShow);

			// do we need it?
			$(window)
				.bind('dragstart', function () {
					if ($('#modal__previewImage, #modal__alert, #modal__previewFrame, #modal__previewAudio, #modal__previewVideo').length) return false
				})
			self.onresize();
			$('#modalContainer').on('focus', 'input[type=text], input[type=number], textarea', function() {
				if ($(window).width() <= APP_SCREEN_THRESHOLD) {
					if (!self.obj_window.hasClass('modal-fullscreen')) self.obj_window.addClass('modal-fullscreen noani swype').css({top: ''}).eachDelayed(function() {
						$(this).removeClass('noani swype');
					}, 300);
				}
			});
			self.window =  App.window.modal.bind(self);
			self.obj_wrapper = $('#modalContainer');

			App.ui.onGesture(self.obj_wrapper, '#modalContainer', self.preview_image.onGestureOptions);
		},

		onLogout: function () {
			// помилки при 2+ рівнях модалок
			// while (App.modal.is_shown()) App.modal.hide({force: true});
			while (App.modal.is_shown()) App.modal.hide({force: true, immediate: true, hide_all: true});
			self.destructor();
		},

		/**
		 * Appends a control to the modal header
		 * @param {jQuery} control - control to append
		 * @param {'before'|'after'|'end'} position - position to append the control
		 */
		append_header_control: function (control, position = 'end') {

			const header = self.obj_window.find('.modal__header');
			if (!header.length) {
				App.core.warn('modal.append_header_control', 'header not found');
				return;
			}

			const position_class = 'modal__header__controls--'+position;

			const find_or_create_controls = () => {
				let controls = header.find('.'+position_class);
				if (!controls.length) {
					controls = $('<div>', {
						class: 'modal__header__controls '+position_class
					});
					const title = header.find(' > .in');
					const gap = title.find(' ~ .flex_gap');

					switch (position) {
						case 'before':
							title.before(controls);
							break;
						case 'after':
							title.after(controls);
							break;
						case 'end':
						default:
							gap.after(controls);
							break;
					}
				}

				return controls;
			};

			find_or_create_controls().append(control);
		},

		helper_validate_preview_url(url) {
			return App.helper.validate.file_view_url.test(url) || App.helper.validate.link_view_url.test(url);
		},

		populate_buttons_to_header: function (options = {}) {
			options = $.extend({}, {
				selector: 'ws-btn[name*="btn-primary"]',
				text: App.object_state.locale.update,
				is_hide_buttons: false,
				is_always_show: false,
				ws_btn_size: 32
			}, options);

			const buttons = self.obj_window.find('div.buttons');
			if (!buttons.length) return;
			if (options.is_hide_buttons) buttons.hide();

			const ws_btn = buttons.find(options.selector).clone();
			ws_btn.attr('text', options.text);

			ws_btn.attr('name', (_, name) => {
				name = name.replace(/btn-\d+/g, '').trim(); // clear original size
				name += ' btn-' + options.ws_btn_size; // set new size
				return name;
			});

			self.append_header_control(ws_btn);

			self.obj_window.find('form').form_change_tracker(() => {
				ws_btn.removeClass('ws-utility-hidden').toggleDisabled(false);
			}, () => {
				ws_btn.toggleClass('ws-utility-hidden', !options.is_always_show).toggleDisabled(true);
			})
		}
	};
})();
